import Router from "next/router";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { profileApi } from "@entities/profile";
import { setAccessToken, setRefreshToken } from "@shared/lib/utils";
import { API } from "../authSlice";
import { hideRegistrationForm } from "../layoutSlice";

export const authByOAuthTelegram = createAsyncThunk(
    "auth/authByOAuthTelegram",
    async (authData: any, thunkAPI) => {
        try {
            const queryString = new URLSearchParams(authData as Record<string, string>).toString();
            const url = `${API}/v1/oauth/telegram/tokens?${queryString}`;
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json"
                }
            });

            const data = await response.json();

            if (response.status === 200) {
                const token = data?.data?.accessToken;
                const refreshToken = data?.data?.refreshToken;
                if (!token) {
                    throw new Error("No token come from server");
                }
                setAccessToken(token);
                setRefreshToken(refreshToken);
                thunkAPI.dispatch(hideRegistrationForm());
                const profileQuery = profileApi.endpoints.getProfile.initiate({
                    accessToken: token
                });
                const res = await thunkAPI.dispatch(profileQuery);
                localStorage.setItem("user", JSON.stringify(res.data));
                await Router.push("/");
                return {
                    ...data,
                    user: res.data
                };
            } else {
                const message = data.message || "Something went wrong";
                return thunkAPI.rejectWithValue({ message });
            }
        } catch (error) {
            const errorMessage =
                error instanceof Error ? error.message : "An unexpected error occurred";
            console.error("Error during Telegram OAuth:", errorMessage);
            return thunkAPI.rejectWithValue({ message: errorMessage });
        }
    }
);